import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback, useContext, useMemo } from 'react';
import { Context } from './Context';
import { DISPLAY_NAME_OPTION } from './constants';
const Option = forwardRef(({ as: Element = 'li', className, children, index, isActive = false, isSelected = false, render, value, ...rest }, ref) => {
    const { id, setActiveOptionIndex, isNavigatingWithKeyboard } = useContext(Context);
    const optionId = useMemo(() => `${id}-option-${value.id}`, [id, value.id]);
    const handleMouseEnter = useCallback(() => {
        if (index !== undefined) {
            setActiveOptionIndex(index);
        }
    }, [index, setActiveOptionIndex]);
    const optionClasses = useMemo(() => {
        if (typeof className === 'function') {
            return className({ isActive, isSelected });
        }
        return className;
    }, [className, isActive, isSelected]);
    return (_jsx(Element, { ...rest, "aria-selected": isSelected, className: optionClasses, "data-active": isActive, "data-pointer-disabled": isNavigatingWithKeyboard, "data-selected": isSelected, "data-testid": optionId, id: optionId, onMouseEnter: handleMouseEnter, ref: ref, role: "option", tabIndex: -1, children: render ? render({ isActive, isSelected }) : children }));
});
Option.displayName = DISPLAY_NAME_OPTION;
export { Option };
//# sourceMappingURL=Option.js.map